export default "__VITE_ASSET__DneR4DnL__"